import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/tools/services/config.service';



@Injectable({
  providedIn: 'root'
})
export class SalesReportsService {

  constructor(
    protected configService     : ConfigService) { }

  ticketOrderPrint(ticketId : number){
    window.open( this.configService.config.reportServerUrl  + 'CommandReport' + '&' + this.configService.config.reportCommand +
    '&pTicketId='  + ticketId);
  }

  porderPrint(porderCode : string)  {
    window.open( this.configService.config.reportServerUrl  + 'CommandReport' + '&' + this.configService.config.reportCommand +
     '&pPorderCode='  + porderCode);
  }

  sinvoicePrint(sinvoiceCode : string)  {
    window.open( this.configService.config.reportServerUrl  + 'InvoicingReport' + '&' + this.configService.config.reportCommand  +
      '&pSinvoiceCode=' + sinvoiceCode);
  }

  productBatchesPrint(warehouseCode : string)  {
    window.open( this.configService.config.reportServerUrl  + 'ProductBatchReport' + '&' + this.configService.config.reportCommand  +
      '&pWrarehouseCode=' + warehouseCode);    
  }
 
  settelmentPrint(){
    window.open( this.configService.config.reportServerUrl  + 'SettlementReport' + '&' + this.configService.config.reportCommand );
  }

  warehouseTransferPrint(warehouseTransferCode : string){
    window.open( this.configService.config.reportServerUrl  + 'ReceveingReport' + '&' + this.configService.config.reportCommand +
    '&pWarehousetransferCode=' + warehouseTransferCode);
  }
  productWarehouseInventoryPrint(warehouseInventoryCode : string)  {
    window.open( this.configService.config.reportServerUrl  + 'Inventaire Stock' + '&' + this.configService.config.reportCommand  +
      '&pWarehouseInventory=' + warehouseInventoryCode);    
  }
}

